import React, { useEffect } from "react";
import Piatti from "components/Piatti";
import Cena from "components/Cena";
import Eventi from "components/Eventi";

import { piatti } from "site-structure.js";

import headerBg from "images/contatti_bg.jpg";

const Cene = ({ title }) => {
	useEffect(() => {
		document.title = title;
	}, [title]);

	return (
		<>
			<section
				className="module module-big bg-dark-30"
				style={{
					backgroundImage: `url(${headerBg})`,
					backgroundSize: "cover",
					backgroundPosition: "50%",
				}}>
				<div className="container">
					<div className="row">
						<div className="col-sm-2 col-sm-offset-5">
							<div className="alt-module-subtitle">
								<span className="holder-w"></span>
								<h5 className="font-serif">Servizi</h5>
								<span className="holder-w"></span>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-sm-8 col-sm-offset-2">
							<h2 className="module-title font-alt mb-0">Alla carta</h2>
						</div>
					</div>
				</div>
			</section>

			<Cena />

			<Piatti
				overtitle="Li abbiamo fatti noi?"
				title="Se sì, non abbiamo fatto apposta"
				gallery={piatti}
			/>

			<Eventi />
		</>
	);
};

export default Cene;
